<template>
    <div>
        <div class="dealer-locator__container">
            <Filters v-model="filtersActive" />
            <div class="dealer-locator__container-results">
                <div class="dealer-locator__header">
                    <h1>Our car dealership and showroom locations across the UK</h1>

                    <button
                        class="btn btn--primary btn-outline dealer-locator__container-filters--toggle" type="button" @click="toggleFilters"
                    >
                        Refine Search
                    </button>
                </div>
                <div class="dealer-results__grid">
                    <template v-if="showLoader">
                        <Skeleton
                            v-for="i in 12"
                            :key="`dealer-skeleton:${i}`"
                        />
                    </template>

                    <template v-else-if="currentDealers.length > 0">
                        <Result
                            v-for="(dealer, index) in currentDealers"
                            :key="`dealer:${index}`"
                            @match-height="handleMatchHeight"

                            :dealer="dealer"
                        />
                    </template>

                    <div v-else class="dealer-results__grid--empty">
                        <p class="alert alert-warning extra-margin-bottom extra-margin-top">
                            No dealers found
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <Pagination
            :pages="pagination"
            @change-page="getDealers($event)"
        />
    </div>
</template>

<script>
    import _debounce from 'lodash/debounce';
    import { defineComponent } from "vue";
    import Filters from '../components/filters/Filters.vue';
    import Result from '../components/single-result/Result.vue';
    import { mapState, mapActions } from "vuex";
    import { mapGetters } from "vuex";
    import Pagination from "../../my-account/components/Pagination.vue";
    import Skeleton from "../components/Skeleton.vue";
    import debounce from 'lodash/debounce';
    import { isEqual } from "lodash";

    export default defineComponent({
        name: 'dealer-locator',

        components: {
            Filters,
            Result,
            Pagination,
            Skeleton
        },

        beforeMount: async function (){
            await this.loadQueryParams(this.$route);
            await this.getDealers();

            this.hasLoaded = true
        },

        data(){
            return {
                showLoader: true,
                hasLoaded: false,
                filtersActive: false
            }
        },

        computed: {
            ...mapState('DealerData', [
                'filters',
                'pagination',
                'isLoading'
            ]),
            ...mapGetters('DealerData', [
                'currentDealers',
                'query'
            ])
        },

        methods: {
            ...mapActions('DealerData', [
                'loadQueryParams',
                'resetDealers',
                'getDealers'
            ]),

            setQueryString: debounce(
                function(query) {
                    this.$router.push({
                        path: this.$route.path,
                        query
                    })
                },
                250
            ),

            toggleFilters(){
                this.filtersActive = !this.filtersActive
            },

            handleMatchHeight: _debounce(function () {
                $('.dealer-locator__result-image-container').matchHeight({
                    byRow: true,
                    property: 'height',
                    target: null,
                    remove: false,
                });
                $('.dealer-locator__result--details-section').matchHeight({
                    byRow: true,
                    property: 'height',
                    target: null,
                    remove: false,
                });
            }, 50),
        },

        watch: {
            filters: {
                handler(){
                    if(this.hasLoaded)
                        this.resetDealers()
                },
                deep: true
            },

            query: {
                handler(query, old){
                    query = structuredClone(query)
                    old = structuredClone(old)

                    if(this.hasLoaded && !isEqual(query, old)){
                        this.setQueryString(query)
                    }
                },
                deep: true
            },

            isLoading: function(currentlyLoading){
                if(!currentlyLoading){ //We've got data
                    setTimeout(() => this.showLoader = false, 250) //So we don't snap between effects when we have data wait a little bit before hiding the skeletons
                    return
                }

                this.showLoader = true
            },
        }
    })
</script>